import { actions } from './actionEvents';

export const toggleFullscreen = (dispatch, value) => {
    if (value) {
        dispatch({ type: actions.SET_FULLSCREEN });
    } else {
        dispatch({ type: actions.REMOVE_FULLSCREEN });
    }
};
